module.exports = __webpack_public_path__ + "img/fusion.ac5ff76b.svg";